import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth';

/**
 * Firebase client SDK - lazy initialisation.
 *
 * Call initFirebase(config) once (from main.tsx) before mounting React.
 * All consumers that import firebaseAuth / googleProvider will receive the
 * live binding and can access them synchronously after initialisation.
 */

// eslint-disable-next-line prefer-const
let _auth!: Auth;
// eslint-disable-next-line prefer-const
let _googleProvider!: GoogleAuthProvider;

export function initFirebase(options: FirebaseOptions): void {
  const app = initializeApp(options);
  _auth = getAuth(app);
  _googleProvider = new GoogleAuthProvider();
  // Request email and profile scopes so we get user identity on first login
  _googleProvider.addScope('email');
  _googleProvider.addScope('profile');
  // Always show the Google account chooser, even when the user already has an
  // active Google session in the browser. Without this, returning users are
  // authenticated silently - the internal Google popup still opens but skips
  // the account selection step, making the flow feel broken.
  _googleProvider.setCustomParameters({ prompt: 'select_account' });
}

export { _auth as firebaseAuth, _googleProvider as googleProvider };
